export default __webpack_public_path__ + "static/media/header-bg-dark.400d4017.png";